import { AnyAction } from '@reduxjs/toolkit';

import { userInitialState } from 'store/initialStates/user';

export const ACTION_TYPES = {
  UPDATE_ANONYMOUS_USER: 'UPDATE_ANONYMOUS_USER',
  UPDATE_USER_FULL: 'UPDATE_USER_FULL',
};

const userReducer = (state = userInitialState, action: AnyAction) => {
  switch (action.type) {
    case '_user':
      return action.payload;
    case ACTION_TYPES.UPDATE_USER_FULL:
      return {
        ...action.payload,
        isLoggedIn: true,
      };
    case ACTION_TYPES.UPDATE_ANONYMOUS_USER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
export default userReducer;
